import { render } from "./Submenu.vue?vue&type=template&id=a8e0ae2c&scoped=true"
import script from "./Submenu.vue?vue&type=script&lang=js"
export * from "./Submenu.vue?vue&type=script&lang=js"

import "./Submenu.vue?vue&type=style&index=0&id=a8e0ae2c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8e0ae2c"]])

export default __exports__